<template>
  <div class="footer" :class="{fixed: fixed, absolute: absolute}">
    <div class="powered">Powered by <a onclick="window.open(this.href);return false;" href="https://pollen-metrology.com">Pollen Metrology™</a></div>
    <div class="funding">{{funding}}</div>
  </div>
</template>

<script>

import values from '../values.json'

export default {
  name: 'Footer',
  props: {
    fixed: Boolean,
    absolute: Boolean,
  },
  data() {
    return {
      funding: values.funding,
    }
  },
}
</script>
<style lang="scss">
@import "../themes.scss";

.footer {
  text-align: center;
  padding-bottom: 10px;
    &.fixed {
      position: fixed;
      left: 0;
      bottom: 0;
      right: 0;
    }

    &.absolute {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .powered {
      color: $primary;
      a {
        color:inherit;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .funding {
      color: $primary;
      padding-top: 10px;
      font-size: 0.8em;
      max-width: 600px;
      margin: auto;
    }
  }
</style>
